import { Toaster } from 'sonner';

export const MessageToaster = () => (
  <Toaster
    id="message-toaster"
    position="top-center"
    offset={48}
    mobileOffset={{ top: 48, right: 0, bottom: 48, left: 0 }}
    swipeDirections={['top', 'left', 'right', 'bottom']}
    toastOptions={{
      style: {
        width: 'fit-content',
        maxWidth: 'calc(100vw - 32px)',
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    }}
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      pointerEvents: 'auto',
    }}
  />
);
